import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
              黑料吃瓜
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-50/60">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <p className="mt-3 text-xs text-background-50/40">
              {siteInfo.slogan}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              订阅爆料
            </h4>
            <div className="relative">
              <input
                type="email"
                placeholder="输入邮箱订阅最新爆料"
                className="w-full bg-transparent border-0 border-b border-background-50/20 pb-2 text-sm text-background-50 placeholder-background-50/30 outline-none focus:border-background-50/50 transition-colors"
              />
              <button className="absolute right-0 top-0 text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" aria-label="订阅">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="mt-3 text-xs text-background-50/30">
              订阅即表示同意我们的
              <Link to="/about" className="underline hover:text-background-50/60 transition-colors cursor-pointer">隐私政策</Link>
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              社交媒体
            </h4>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="px-4 md:px-6 py-10 flex items-end justify-center overflow-hidden">
          <span className="font-heading text-[clamp(3rem,10vw,8rem)] font-black text-background-50/[0.04] tracking-tighter select-none leading-none whitespace-nowrap">
            HEILIAO
          </span>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto">
          <p className="text-xs text-background-50/30">
            &copy; 2025 黑料吃瓜爆料中心 版权所有
          </p>
          <div className="flex gap-4 text-xs text-background-50/30">
            <Link to="/about" className="hover:text-background-50/50 transition-colors cursor-pointer">隐私政策</Link>
            <Link to="/about" className="hover:text-background-50/50 transition-colors cursor-pointer">用户协议</Link>
            <Link to="/about" className="hover:text-background-50/50 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}